module.exports = new __parcel__URL__("inquiry_ko.6c5cd86d.webp").toString();